import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { SaaSTokenParam } from '../../interfaces/referral.interface';
import { CollaborationService } from '../../services/collaboration.service';
// LEGACY: mobile PDF rendering via pdfjs-dist + CDN worker. Replaced by collaboration-ui-pdf-renderer
// (ngx-extended-pdf-viewer) which handles mobile via [isMobileScreen]. Kept commented as fall-back.
import { GlobalWorkerOptions, PDFDocumentProxy, getDocument } from 'pdfjs-dist';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';
GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.10.111/pdf.worker.min.js';

@Component({
    selector: 'collaboration-ui-doc-viewer',
    templateUrl: './doc-viewer.component.html',
    styleUrl: './doc-viewer.component.scss',
    imports: [MatDialogClose, MatProgressSpinner, MatTooltip, CdkScrollable, MatDialogContent, AssetUrlPipe]
})
export class DocViewerComponent {
  previewData: any;
  showLoader = false;
  constructor(private dialog: MatDialog, private collaborationService: CollaborationService) { }

  @ViewChild('previewWindow', { static: true })
  previewWindow!: TemplateRef<any>;
  token = SaaSTokenParam;
  @Output() onPreviewClose = new EventEmitter<void>();
  @Input() isMobileScreen!: boolean;
  // LEGACY: container for the old pdfjs-dist mobile renderer. Kept commented as fall-back.
  @ViewChild('pdfContainer', { static: false }) pdfContainer!: ElementRef<HTMLDivElement>;

  @Input()
  set document(element: any) {
    if (element) {
      this.previewData = element;
      const dialogRef = this.dialog.open(this.previewWindow, {
        data: element,
        height: '100%',
        width: '95%',
        maxWidth: '100%',
        disableClose: true,
        panelClass: 'doc-viewer-dialog',
        autoFocus: false
      });
      dialogRef.afterClosed().subscribe(result => {
        this.onPreviewClose.emit();
      });

      // LEGACY: trigger the pdfjs-dist mobile canvas render. Replaced by collaboration-ui-pdf-renderer.
      dialogRef.afterOpened().subscribe(() => {
        if (this.isMobileScreen && element.blob) {
          setTimeout(() => {
            this.renderPdfToCanvas(element.blob);
          }, 100);
        }
      });

    } else {
      this.dialog.closeAll();
    }
  }

  // LEGACY: rendered each PDF page to a canvas inside #pdfContainer for mobile preview.
  // Replaced by ngx-extended-pdf-viewer which handles mobile natively (pinch-zoom, paging).
  async renderPdfToCanvas(blob: Blob) {
    if (!this.pdfContainer || !this.pdfContainer.nativeElement) {
      return;
    }
    const url = URL.createObjectURL(blob);
    const loadingTask = getDocument(url);
    const pdf: PDFDocumentProxy = await loadingTask.promise;
  
    // Clear previous canvases
    this.pdfContainer.nativeElement.innerHTML = '';
  
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const viewport = page.getViewport({ scale: 1.5 });
  
      // Create a new canvas for each page
      const canvas = document.createElement('canvas');
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      const context = canvas.getContext('2d')!;
  
      await page.render({ canvasContext: context, viewport }).promise;
      this.pdfContainer.nativeElement.appendChild(canvas);
    }
    URL.revokeObjectURL(url);
  }

  downloadFile() {
    this.showLoader = true;
    this.collaborationService.downloadDocument(this.previewData.blobId, {
      "spaceId": '',
      "appId": '',
      "fileExtension": this.previewData.fileExtension
    }, 'downloadFile').subscribe({
      next: (response: any) => {
        this.showLoader = false;
        const blob = new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.previewData.name;
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
        this.collaborationService.displaySuccessMessage('File downloaded successfully.');
      }, error: (err: any) => {
        this.showLoader = false;
        this.collaborationService.displayErrorMessage(err, 'Error downloading the file. Please try again.');
      }
    });

  }
}
